//
//
//
//
//
//
//
//
//
//

import { addDays, subDays, isAfter, isSameDay } from 'date-fns'

export default {
  props: {
    value: {
      type: Date,
      default: new Date(),
    },
    max: {
      type: Date,
      default: null,
    },
  },

  computed: {
    isMax() {
      if (!this.max) {
        return false
      }

      return isSameDay(this.value, this.max) || isAfter(this.value, this.max)
    },
  },

  methods: {
    last() {
      const newValue = subDays(this.value, 1)

      this.$emit('input', newValue)
      this.$emit('change', newValue)
    },
    next() {
      const newValue = addDays(this.value, 1)

      this.$emit('input', newValue)
      this.$emit('change', newValue)
    },
  },
}
